import React from 'react';
import { shape, string } from 'prop-types';

function CarousalItem({ img, title, content }) {
  return (
    <div className="tw-flex tw-justify-center tw-p-4 tw-min-h-full tw-w-full tw-items-center carousel-slider-item">
      <div className="tw-w-1/2 tw-flex tw-justify-center image-div">
        <img
          className="tw-object-contain tw-object-center tw-h-auto tw-w-auto"
          src={img.src}
          alt={img.alt}
          loading="lazy"
        />
      </div>
      <div className="tw-w-1/2 tw-p-4 content-div">
        <h3 className="how-it-works-heading">{title}</h3>
        <p className="how-it-works-content">{content}</p>
      </div>
    </div>
  );
}

CarousalItem.propTypes = {
  img: shape({
    src: string.isRequired,
    alt: string.isRequired,
  }).isRequired,
  title: string.isRequired,
  content: string.isRequired,
};

CarousalItem.defaultProps = {};

export { CarousalItem };
